import { Chip } from '@mui/material';
import ToolTipText from '../../CustomTableWithPagination/ToolTipText';
import ToolTip from '../../ToolTip/ToolTip';

export const COURSE_PURCHASE_TABLE_HEAD = [
  { field: 'serialNumber', headerName: 'Sl No', width: 100 },
  { field: 'admission_number', headerName: 'Admn No', width: 100 },
  { field: 'student_name', headerName: 'Student Name', width: 250 },
  {
    field: 'mob_no',
    headerName: 'Phone Number',
    width: 200,
    renderCell: (params) => {
      return (
        <ToolTip
          expand={`${params.row.country_code} ${params.row.mob_no}`}
          content={`${params.row.country_code} ${params.row.mob_no}`}
        />
      );
    },
  },
  {
    field: 'course_name',
    headerName: 'Requested Course',
    width: 200,
    renderCell: (params) => {
      return <ToolTip content={params.row.course_name} expand={params.row.course_name} />;
    },
  },
  {
    field: 'created_at',
    headerName: 'Requested On',
    width: 250,
  },
  { field: 'project_name', headerName: 'Project Name', width: 200 },
  {
    field: 'cro_name',
    headerName: 'Assigned CRO',
    width: 200,
    renderCell: (params) =>
      params.row.cro_id === null ? (
        <Chip label="Not Assigned" variant="outlined" color="info" size="small" />
      ) : (
        params.row.cro_name
      ),
  },
  {
    field: 'assigned_by',
    headerName: 'Assigned By',
    width: 200,
    renderCell: (params) =>
      params.row.cro_id === null ? (
        <Chip label="Not Assigned" variant="outlined" color="info" size='small'/>
      ) : (
        params.row.assigned_by
      ),
  },
];
